<template>
	<div class="wutuNew">
		<ul class="newListUl">
			<li v-for="(item,index) in dataList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
		    <router-link  :to="item.Url" :href="item.Url">
		      <div class="titles flexDiv">
		        <span v-html="item.Title"></span>
		        <i>{{item.ShowTime}}</i>
		      </div>
		      <p v-html="item.Describe"></p>
		    </router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'noImgList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style>
	.newListUl{
		width: 7.02rem;
		margin: 0 auto;
	}
	.newListUl li{
		margin-top: 0.2rem;
		margin-bottom: 0.6rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/noImgList.vue